// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Sv30","tabsBox":"styles_tabsBox__3nfvo","createButton":"styles_createButton__hJ-PO"};